import React from "react";
import { motion } from "framer-motion";
import MaButton from "../../../Components/UI/ma-button";
import { PlanCard } from "./plan-card";
import { screenVariants } from "./plan-config";

export function PlanListScreen({
  plans,
  selected,
  selectedPlan,
  onBack,
  onContinue,
  onPlanSelect,
}) {
  return (
    <motion.div
      key="plans"
      variants={screenVariants}
      initial="enter"
      animate="center"
      exit="exit"
    >
      <div className="mb-8">
        <h1 className="my-0 text-[20px] font-black tracking-tight text-[#353535] sm:text-[26px]">
          Choose your plan
        </h1>
        <p className="my-0 mt-2 text-[14px] leading-relaxed text-[#458082] sm:text-[16px]">
          Start free or unlock more. Upgrade anytime from your dashboard.
        </p>
      </div>

      <div className="flex flex-col gap-5">
        {plans.map((plan) => (
          <PlanCard
            key={plan.id}
            plan={plan}
            selected={selectedPlan === plan.id}
            onSelect={onPlanSelect}
          />
        ))}
      </div>

      <div className="mt-10 flex items-center gap-4">
        <div>
          <MaButton
            title="Back"
            variant="outlined"
            onClick={onBack}
            sx={{
              bgcolor: "#F0F0F0",
              color: "#181818",
              minHeight: "48px",
              borderRadius: "16px",
              fontSize: "14px",
              fontWeight: 500,
              boxShadow: "none",
              border: "none",
              "&:hover": { bgcolor: "#E8E8E8", boxShadow: "none" },
            }}
          />
        </div>
        <div className="flex-1">
          <MaButton
            fullWidth
            variant="primary"
            title={
              selected.id === "free"
                ? "Continue"
                : `Continue with ${selected.name}`
            }
            onClick={onContinue}
            sx={{
              bgcolor: "#2E1834",
              minHeight: "48px",
              borderRadius: "16px",
              fontSize: "14px",
              fontWeight: 600,
              "&:hover": { bgcolor: "#3B2142" },
            }}
          />
        </div>
      </div>
    </motion.div>
  );
}
